/* eslint-disable no-new */
import { App } from 'vue';
import ICMMenu from './ICMMenu.vue';
import ICMMenuSubmenu from './components/ICMMenuSubmenu.vue';
import ICMMenuItem from './components/ICMMenuItem.vue';
import ICMMenuTitle from './components/ICMMenuTitle.vue';

export default {
  async install(Vue: App) {
    Vue.component('IcmMenu', ICMMenu);
    Vue.component('IcmMenuSubmenu', ICMMenuSubmenu);
    Vue.component('IcmMenuItem', ICMMenuItem);
    Vue.component('IcmMenuTitle', ICMMenuTitle);
  },
};

export interface ICMMenuInterface {
  IcmMenu: typeof ICMMenu;
  IcmMenuSubmenu: typeof ICMMenuSubmenu;
  IcmMenuItem: typeof ICMMenuItem;
  IcmMenuTitle: typeof ICMMenuTitle;
}
